import { Component } from '@angular/core';
import { ListService } from '@abp/ng.core';
import { CardBodyComponent, CardComponent, ConfirmationService } from '@abp/ng.theme.shared';
import { CrudPage } from '@zendra/shared';
import { GetGisStandInconsistenciesInputDto, GisStandInconsistencyCase } from 'orchestrator';
import { GisStandInconsistencyBase } from '../gis-stand-inconsistency/gis-stand-inconsistency-base';
import {
  GISSTANDINCONSISTENCYDISABLEDINZENDRA_CONFIG,
  GISSTANDINCONSISTENCYDISABLEDINZENDRA_FIELDS,
} from './gis-stand-inconsistency-disabled-in-zendra.config';

@Component({
  selector: 'app-gis-stand-inconsistency-disabled-in-zendra',
  imports: [CardComponent, CardBodyComponent, CrudPage],
  providers: [ListService, ConfirmationService],
  templateUrl: '../gis-stand-inconsistency/gis-stand-inconsistency.html',
})
export class GisStandInconsistencyDisabledInZendra extends GisStandInconsistencyBase {
  config = GISSTANDINCONSISTENCYDISABLEDINZENDRA_CONFIG;
  fields = GISSTANDINCONSISTENCYDISABLEDINZENDRA_FIELDS;

  protected override get caseFilter(): Partial<GetGisStandInconsistenciesInputDto> {
    return { case: GisStandInconsistencyCase.DisabledInZendra };
  }

  protected getEntityName(): string {
    return 'GisStandInconsistencyDisabledInZendra';
  }
}